import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';
import { GetCourseLearningObjectTypeRequestType } from 'shared/common/dtos/course/getCourseLearningObjectType';

export const courseLearningObjectTypeQueryKey = (learningObjectId?: string) =>
  ['course-learning-object-type', { learningObjectId }] as const;

export const getCourseLearningObjectType = async (learningObjectId: string) => {
  const data = await apiCall(
    apiClient.GET('/course-drafts/learning-object-type', {
      params: { query: { learningObjectId } }
    })
  );
  return data;
};

export const useGetCourseLearningObjectTypeQuery = ({
  learningObjectId
}: Partial<GetCourseLearningObjectTypeRequestType>) => {
  return useQuery({
    queryKey: courseLearningObjectTypeQueryKey(learningObjectId),
    queryFn: () => (learningObjectId?.length ? getCourseLearningObjectType(learningObjectId) : Promise.reject()),
    enabled: !!learningObjectId
  });
};
